var map = {
	"./HalloTaxiStern_Icon.png": 196,
	"./HalloTaxiStern_Logo.png": 354,
	"./HalloTaxiStern_Schriftzug.png": 36,
	"./NextCab_Fahrzeug.png": 904,
	"./NextCab_Schriftzug.png": 957,
	"./taxi-map.jpg": 545
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;